<template>
  <div v-if="totalPages > 1" class="flex flex-row gap-2 justify-center items-center">
    <div
      v-for="page in totalPages"
      class="rounded-full transition-all duration-200"
      :style="dotStyle(page)"
      :key="page"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'Pagination',
  props: {
    currentPage: {
      type: Number,
      default: 1,
    },
    totalPages: {
      type: Number,
      default: 1,
    },
    passiveColor: {
      type: String,
      default: '#F0F2F4',
    },
    activeColor: {
      type: String,
      default: '#0B0C0F',
    },
    /** Width of the active indicator in px. Use 8 for dot, 16 for pill. */
    activeWidth: {
      type: Number,
      default: 8,
    },
    dotSize: {
      type: Number,
      default: 8,
    },
  },
  methods: {
    dotStyle(page) {
      const isActive = page === this.currentPage;
      return {
        width: `${isActive ? this.activeWidth : this.dotSize}px`,
        height: `${this.dotSize}px`,
        backgroundColor: isActive ? this.activeColor : this.passiveColor,
      };
    },
  },
};
</script>
